export class UsuarioPerfil {
    constructor(public tipo: string, public rut_usuario: string,  public id_sistema: number, public id_perfil: number, public vigente: boolean, public nombre_usuario: string) {}
} 